import { useMutation } from '@apollo/client';
import { gql } from '__generated__';
import { UserType } from '__generated__/graphql';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { FormInput, FormPanel } from 'components/FormPanel';

import pngLogo from 'media/pngLogo.png';

import { storeLoginCredentials } from 'utils/auth';

import theme from './theme.module.scss';

const LOGIN_MUTATION = gql(`
  mutation Mutation($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        id
        fullName
        role
      }
    }
  }
`);

const Login: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirectTo = searchParams.get('redirectTo');

  const [login, { error, loading }] = useMutation(LOGIN_MUTATION);

  return (
    <div className={theme.container}>
      <div className={theme.inner}>
        <NavLink to="/" className={theme.logoContainer}>
          <img className={theme.logo} src={pngLogo} alt="PNG logo" height={64} />{' '}
          <span>Employees Directory</span>
        </NavLink>
        <h2>Sign in.</h2>
        <FormPanel
          loading={loading}
          error={error}
          onSubmit={formData => {
            login({
              variables: {
                email: formData.email,
                password: formData.password,
              },
            }).then(({ data }) => {
              if (data?.login?.token) {
                storeLoginCredentials(data.login.user as UserType, `Bearer ${data.login.token}`);
                navigate(redirectTo || '/');
              }
            });
          }}
          submitButtonLabel="Login"
        >
          <FormInput fieldName="email" type="string" defaultValue="" label="Email" fullWidth />
          <FormInput
            fieldName="password"
            type="password"
            defaultValue=""
            label="Password"
            fullWidth
          />
        </FormPanel>
        <p className={theme.information}>
          Forgot Password? <Link to="/reset-password">Reset here</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
